import { AlertTriangle, Boxes, CheckCircle2, XCircle } from "lucide-react";

const CARDS = [
  { key: "total", label: "Total products", icon: Boxes, tone: "text-[#1B4332] bg-[#E6F2EA]", filter: "" },
  { key: "in_stock", label: "In stock", icon: CheckCircle2, tone: "text-[#1B4332] bg-[#E6F2EA]", filter: "In Stock" },
  { key: "low_stock", label: "Low stock", icon: AlertTriangle, tone: "text-[#7A5A0B] bg-[#FBF1D6]", filter: "Low Stock" },
  { key: "out_of_stock", label: "Out of stock", icon: XCircle, tone: "text-[#8A2B1E] bg-[#F6E4E1]", filter: "Out of Stock" },
];

export const StatCards = ({ stats, onFilter }) => (
  <div className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-testid="admin-stat-cards">
    {CARDS.map(({ key, label, icon: Icon, tone, filter }) => (
      <button key={key} onClick={() => onFilter(filter)} data-testid={`stat-card-${key.replace(/_/g, "-")}`}
              className="flex items-center gap-4 rounded-2xl border border-[#E5E0D8] bg-white p-4 text-left transition-shadow hover:shadow-md sm:p-5">
        <span className={`grid h-11 w-11 place-items-center rounded-xl ${tone}`}><Icon className="h-5 w-5" /></span>
        <span>
          <span className="block font-display text-2xl sm:text-3xl font-bold text-[#1F2421]" data-testid={`stat-value-${key.replace(/_/g, "-")}`}>{stats?.[key] ?? "–"}</span>
          <span className="text-xs sm:text-sm text-[#5B625D]">{label}</span>
        </span>
      </button>
    ))}
  </div>
);
